// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 81vh;
}

.loading-icon {
    padding-top: 10px;
}

.weather-section {
    float: left;
}

.weather-section.title {
    display: flex;
    align-items: stretch;
}

.weather-section.right {
    margin-top: 20%;
    float: right;
}

.weather-staggered-enter {
    opacity: 0;
    transform: translateY(-10px);
  }
  
.weather-staggered-enter-active {
opacity: 1;
transform: translateY(0);
transition: opacity 500ms, transform 500ms;
}

.weather-staggered-exit {
opacity: 1;
}

.weather-staggered-exit-active {
opacity: 0;
transition: opacity 500ms;
}

.error {
    font-style: red;
}

@keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-20%);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  

.fade-in-left {
    animation: fadeInLeft 3s ease;
}
  

.hidden {
    display: none;
}

.result {
  align-items: center;
}

@media (max-width: 768px) { /* Change the breakpoint to the desired medium screen width */
    .result {
      display: block !important;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Weather.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,4BAA4B;EAC9B;;AAEF;AACA,UAAU;AACV,wBAAwB;AACxB,0CAA0C;AAC1C;;AAEA;AACA,UAAU;AACV;;AAEA;AACA,UAAU;AACV,yBAAyB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;;AAGF;IACI,6BAA6B;AACjC;;;AAGA;IACI,aAAa;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B,6DAA6D;IACrF;MACE,yBAAyB;IAC3B;EACF","sourcesContent":["#main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 81vh;\n}\n\n.loading-icon {\n    padding-top: 10px;\n}\n\n.weather-section {\n    float: left;\n}\n\n.weather-section.title {\n    display: flex;\n    align-items: stretch;\n}\n\n.weather-section.right {\n    margin-top: 20%;\n    float: right;\n}\n\n.weather-staggered-enter {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  \n.weather-staggered-enter-active {\nopacity: 1;\ntransform: translateY(0);\ntransition: opacity 500ms, transform 500ms;\n}\n\n.weather-staggered-exit {\nopacity: 1;\n}\n\n.weather-staggered-exit-active {\nopacity: 0;\ntransition: opacity 500ms;\n}\n\n.error {\n    font-style: red;\n}\n\n@keyframes fadeInLeft {\n    from {\n      opacity: 0;\n      transform: translateX(-20%);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n  \n\n.fade-in-left {\n    animation: fadeInLeft 3s ease;\n}\n  \n\n.hidden {\n    display: none;\n}\n\n.result {\n  align-items: center;\n}\n\n@media (max-width: 768px) { /* Change the breakpoint to the desired medium screen width */\n    .result {\n      display: block !important;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
